import { render, staticRenderFns } from "./EditDeal.vue?vue&type=template&id=084a2cf8&scoped=true&"
import script from "./EditDeal.vue?vue&type=script&lang=js&"
export * from "./EditDeal.vue?vue&type=script&lang=js&"
import style0 from "./EditDeal.vue?vue&type=style&index=0&id=084a2cf8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "084a2cf8",
  null
  
)

export default component.exports